import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <p className="footer-copy">© 2026 ICAO — International Class Academic Office, Telkom University. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
